import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { SettingsService } from '../common/settings.service';

@Injectable()
export class ReservationsService {
    constructor(private httpClient: HttpClient, private authService: AuthService, private settings: SettingsService) { }

    getReservationsOf(plate: string) {
        const headers = new HttpHeaders()
            .set('LoginRole', `${this.authService.getUserLoginRole()}`)
            .set('Authorization', this.authService.getUserToken());
        const url = `${this.settings.serverNomenclator}ParkingReservation/GetByPlateOf?plate=${plate}`;

        return this.httpClient.get(url, { headers: headers });
    }
}